export default __webpack_public_path__ + "static/media/logo.a8e92c52.png";